import ViewAppAccess from "../components/AppAccess/ViewAppAccess";

const AppAccessPage: React.FC = () => {
  return <ViewAppAccess />;
};

export default AppAccessPage;
